import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HardHat, SignOut, User, House } from "@phosphor-icons/react";

export default function Navbar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const isActive = (p) => pathname === p;

    return (
        <header
            data-testid="main-nav"
            className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-black/10"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
                    <div className="w-9 h-9 bg-black flex items-center justify-center">
                        <HardHat size={20} weight="fill" color="#E63946" />
                    </div>
                    <div className="flex flex-col leading-none">
                        <span className="font-display text-lg font-black tracking-tighter">
                            BUILDERS<span className="text-[#E63946]">.</span>GALLERY
                        </span>
                        <span className="text-[10px] tracking-[0.25em] text-neutral-500 uppercase">
                            co.uk
                        </span>
                    </div>
                </Link>

                <nav className="hidden md:flex items-center gap-8">
                    <Link
                        to="/discover"
                        data-testid="nav-discover"
                        className={`text-sm font-medium hover:text-[#E63946] transition-colors ${isActive("/discover") ? "text-[#E63946]" : "text-neutral-700"}`}
                    >
                        Discover
                    </Link>
                    <Link
                        to="/advertise"
                        data-testid="nav-advertise"
                        className={`text-sm font-medium hover:text-[#E63946] transition-colors ${isActive("/advertise") ? "text-[#E63946]" : "text-neutral-700"}`}
                    >
                        Advertise
                    </Link>
                    {user && (
                        <Link
                            to="/dashboard"
                            data-testid="nav-dashboard"
                            className={`text-sm font-medium hover:text-[#E63946] transition-colors ${isActive("/dashboard") ? "text-[#E63946]" : "text-neutral-700"}`}
                        >
                            Dashboard
                        </Link>
                    )}
                    {user?.role === "admin" && (
                        <Link
                            to="/admin"
                            data-testid="nav-admin"
                            className={`text-sm font-medium hover:text-[#E63946] transition-colors ${isActive("/admin") ? "text-[#E63946]" : "text-neutral-700"}`}
                        >
                            Admin
                        </Link>
                    )}
                </nav>

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <Link
                                to={`/b/${user.slug}`}
                                data-testid="nav-public-profile"
                                className="hidden sm:inline-flex btn-ghost text-xs"
                            >
                                <House size={16} /> My Profile
                            </Link>
                            <button
                                data-testid="nav-logout-btn"
                                onClick={() => {
                                    logout();
                                    navigate("/");
                                }}
                                className="btn-ghost text-xs"
                            >
                                <SignOut size={16} /> Sign out
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/login"
                                data-testid="nav-login"
                                className="text-sm font-medium hover:text-[#E63946]"
                            >
                                Sign in
                            </Link>
                            <Link to="/register" data-testid="nav-register" className="btn-accent text-xs">
                                <User size={14} weight="bold" /> Get listed
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
